// Formula define const (actionName + route + type) for example = chargeAccountBtn


export const actionPages = () => ({



   //============================================================= ورود یکپارچه ===============================================================================
   // /Keys/AddApiKey - افزودن کلید جدید
   contentAddKeyPage: 'clients.add',

   // /Keys - لیست کلیدها
   contentKeyListPage: 'clients.list',
   getNewTokenKeyListBtn: 'clients.list.api-token.create',
   removeAllTokenKeyListBtn: 'clients.list.api-token.delete',
   removeKeyListBtn: 'clients.delete',
   updateKeyListBtn: 'clients.update',

   //=============================================================== مدیریت کسب و کار   =============================================================================
   // /BusinessInfo - مدیریت کسب و کار - ویرایش اطلاعات کسب و کار و  احراز هویت
   contentAuthPage: 'bim.auth',
   newRequestAuthBtn: 'bim.auth.new.request',
   contentBusinessPage: 'bim.businessInfo',
   newRequestBusinessBtn: 'bim.auth.new.request',

   // /user-settings - مدیریت کسب و کار -   مدیریت کاربری - دسترسی اعطا شده
   AccessGrantedBusinessTab: 'oauth2.grants.read',
   AccessDeviceBusinessTab: 'oauth2.device.read',
   reportActivityBusinessTab: 'oauth2.activity.read',
   updateUserNameBusinessTab: 'oauth2.username.update',
   updatePasswordBusinessTab: 'oauth2.password.update',

   //دسترسی اعطا شده
   newAccessGrantedBusinessBtn: 'oauth2.grants.create',
   deleteAccessGrantedBusinessBtn: 'oauth2.grants.delete',
   usersAccessGrantedBusinessBtn: 'oauth2.grants.users',


   //دستگاه های فعال  
   deviceBusinessBtn: 'oauth2.device.delete',

   // مدیریت دسترسی‌ ها
   contentACLPage: 'bim.acl.group', // لیست دسترسی 
   craeteACLBtn: 'acl.groups.create',
   updateACLBtn: 'acl.groups.update',
   deleteACLBtn: 'acl.groups.delete',
   addACLUsersBtn: 'acl.user.groups.add',


   //=================================================================  عملیات مالی و بانکی  ===========================================================================
   // حساب دیجیتال من


   // /BillsPayment - پرداخت قبوض
   billInqueryTab: 'utility.bill.inquiry',

   // /Account - حساب دیجیتال من
   contentAccountsDigitalPage: 'bfo.accounts.list',
   contentImprestAccountsDigitalPage: 'org.imprest.accounts.list',

   MoneyTransferAccountBtn: 'accounts.digital.transfer-to-me', //'انتقال وجه'
   MoneyImprestTransferAccountBtn: 'org.imprest.accounts.digital.transfer-to-me', //'انتقال وجه'

   chargeAccountBtn: 'accounts.digital.charge', //'شارژ'
   chargeImprestAccountBtn: 'org.imprest.accounts.digital.charge', //'شارژ'


   reportAccountBtn: 'accounts.digital.report', //'گزارش صورتحساب'
   reportAccountTransactionBtn: 'bfo.accounts.transactions', //'گزارش صورتحساب'
   reportImprestAccountBtn: 'org.imprest.accounts.list.digital.report', //'گزارش صورتحساب'
   reportPageImprestAccountBtn: 'org.imprest.accounts.digital.report', //'گزارش صورتحساب'

   reportDocumentAccountBtn: 'accounts.digital.report.document', //'گزارش صورتحساب -  مدارک'
   reportAccountsDocumentAccountBtn: 'bfo.accounts.list.accounts.report.document', //'گزارش صورتحساب -  مدارک'
   reportImprestDocumentAccountBtn: 'accounts.digital.report.document', //'گزارش صورتحساب -  مدارک'
   reportImprestListDigitalDocumentAccountBtn: 'org.imprest.accounts.list.digital.report.document', //'گزارش صورتحساب -  مدارک'
   reportImprestDigitalDocumentAccountBtn: 'org.imprest.accounts.digital.report.document', //'گزارش صورتحساب'



   reportTagAccountBtn: 'accounts.digital.report.tag', //'گزارش صورتحساب'
   reportAccountTagAccountBtn: 'bfo.accounts.list.accounts.report.tag', //'گزارش صورتحساب'
   reportImprestTagAccountBtn: 'org.imprest.accounts.digital.report.tag', //'گزارش صورتحساب'
   reportImprestDigitalTagAccountBtn: 'org.imprest.accounts.list.digital.report.tag', //'گزارش صورتحساب'


   reportOfflineAccountBtn: 'accounts.digital.report.offline', //'گزارش صورتحساب'
   reportExportAccountBtn: 'accounts.guild.report.export', //'گزارش صورتحساب'
   reportExportAccountDigitalBtn: 'accounts.digital.report.export', //'گزارش صورتحساب'
   reportImprestExportAccountDigitalBtn: 'org.imprest.accounts.digital.report.export', //'گزارش صورتحساب'
   reportAcoountExportAccountDigitalBtn: 'bfo.accounts.list.accounts.report.export', //'گزارش صورتحساب'
   reportAcoountDigitalExportAccountDigitalBtn: 'org.imprest.accounts.list.digital.report.export', //'گزارش صورتحساب'



   withdrawAccountBtn: 'accounts.digital.single-withdraw', //'برداشت وجه'

   withdrawImprestAccountBtn: 'org.imprest.accounts.digital.single-withdraw', //'برداشت وجه'

   depositIdAccountBtn: 'accounts.digital.payment-number', //'دریافت شناسه واریز'
   depositImprestIdAccountBtn: 'org.imprest.accounts.digital.payment-number', //'دریافت شناسه واریز'

   FinancialLicensesAccountBtn: 'accounts.digital.granted-permissions.read', //'مجوز های مالی اعطا شده'
   FinancialImprestLicensesAccountBtn: 'org.imprest.accounts.digital.granted-permissions.read', //'مجوز های مالی اعطا شده'

   FinancialLicensesReciveAccountBtn: 'accounts.digital.received-permissions.list', //'مجوز های مالی دریافت شده'
   FinancialImprestLicensesReciveAccountBtn: 'org.imprest.accounts.digital.received-permissions.list', //'مجوز های مالی دریافت شده'


   // /GrantedWallet - مجوزهای مالی اعطا شده
   financialLicensesGrantedWalletBtn: 'accounts.digital.granted-permissions.create', //  اعطای مجوز مالی
   financialImprestLicensesGrantedWalletBtn: 'org.imprest.accounts.digital.granted-permissions.create', //  اعطای مجوز مالی

   financialLicensesGrantedWalletActionCancelBtn: 'accounts.digital.granted-permissions.cancel', //  عملیات جدول -  لغو
   financialImprestLicensesGrantedWalletActionCancelBtn: 'org.imprest.accounts.digital.granted-permissions.cancel', //  عملیات جدول -  لغو

   financialLicensesGrantedWalletActionConfirmBtn: 'accounts.digital.granted-permissions.confirm', //  عملیات جدول - تایید
   financialImprestLicensesGrantedWalletActionConfirmBtn: 'org.imprest.accounts.digital.granted-permissions.confirm', //  عملیات جدول - تایید

   financialLicensesGrantedWalletActionDeleteBtn: 'accounts.digital.granted-permissions.delete', //  عملیات جدول -  حذف
   financialImprestLicensesGrantedWalletActionDeleteBtn: 'org.imprest.accounts.digital.granted-permissions.delete', //  عملیات جدول -  حذف



   // /ReceivedWallet - مجوزهای مالی دریافت شده
   financialLicensesReciveActionCancelBtn: 'accounts.digital.received-permissions.cancel', //  عملیات جدول -  لغو
   financialImprestLicensesReciveActionCancelBtn: 'org.imprest.accounts.digital.received-permissions.cancel', //  عملیات جدول -  لغو

   financialLicensesReciveActionConfirmBtn: 'accounts.digital.received-permissions.confirm', //  عملیات جدول -  تایید
   financialImprestLicensesReciveActionConfirmBtn: 'org.imprest.accounts.digital.received-permissions.confirm', //  عملیات جدول -  تایید

   financialLicensesReciveActionDeleteBtn: 'accounts.digital.received-permissions.delete', //  عملیات جدول - حذف 
   financialImprestLicensesReciveActionDeleteBtn: 'org.imprest.accounts.digital.received-permissions.delete', //  عملیات جدول - حذف 


   // /TransactionsWallet - صورت حساب تراکنش
   transactionReceiptReciveActionList: 'accounts.digital.report.transaction.read', //   رسید تراکنش 
   transactionAccountsReceiptReciveActionList: 'bfo.accounts.list.accounts.report.transaction.read', //   رسید تراکنش 
   transactionImprestReceiptReciveActionList: 'org.imprest.accounts.digital.report.transaction.read', //   رسید تراکنش 
   transactionImprestDigitalReceiptReciveActionList: 'org.imprest.accounts.list.digital.report.transaction.read', //   رسید تراکنش 
   transactionReceiptShareReciveActionList: 'accounts.digital.report.transaction.read', //   رسید تراکنش اشتراک گذاری 
   transactionReceipPdftReciveActionList: 'accounts.digital.report.transaction.read', //   رسید تراکنش دانلود pdf

   // /WalletCartableCashout - ثبت درخواست برداشت وجه
   groupWalletCartableCashoutTab: 'accounts.digital.multiple-withdraw', //   برداشت وجه گروهی



   // /WalletCartableCashout - ثبت درخواست برداشت وجه
   groupImprestWalletCartableCashoutTab: 'org.imprest.accounts.digital.multiple-withdraw', //   برداشت وجه گروهی


   // /SettlementWallet - درخواست‌های تسویه از حساب دیجیتال
   settelmentAccountDigitalPage: 'bfo.accounts.settlement-list-wallet', //  درخواست‌های تسویه از حساب دیجیتال
   settelmentImprestAccountDigitalPage: 'org.imprest.accounts.settlement-list-wallet', //  درخواست‌های تسویه از حساب دیجیتال


   // /SettlementWallet - درخواست‌های تسویه از حساب دیجیتال
   settelmentExportAccountDigitalPage: 'accounts.digital.settlement.export', //  درخواست‌های تسویه از حساب دیجیتال 
   settelmentImprestExportAccountDigitalPage: 'org.imprest.accounts.digital.settlement.export', //  درخواست‌های تسویه از حساب دیجیتال 


   // /DirectDebit - مجوزهای برداشت از حساب بانکی
   directDebitAccountDigitalPage: 'bfo.accounts.direct-debit.list', // مجوزهای برداشت از حساب بانکی 

   // /WithdrawRule - مجوزهای برداشت از حساب دیجیتال
   withdrawRuleAccountDigitalPage: 'bfo.accounts.withdraw-rule.list', // مجوزهای برداشت از حساب دیجیتال

   // /TransferCredit - انتقال وجه تکی/گروهی
   transferAccountDigitalPage: 'bfo.accounts.transfer', // انتقال وجه تکی/گروهی - عملیات گروهی
   transferImprestAccountDigitalPage: 'org.imprest.accounts.transfer', // انتقال وجه تکی/گروهی - عملیات گروهی




   // حساب‌های تفصیلی

   // /Guilds - لیست حساب‌ها
   contentGuildPage: 'bfo.guilds.list', //  لیست حساب ها 
   transferGuildBtn: 'accounts.guild.transfer-to-me', //  دکمه انتقال وجه
   withdrawGuildBtn: 'accounts.guild.withdraw', //  دکمه برداشت وجه
   reportGuildBtn: 'accounts.guild.report', //  دکمه گزارش صورتحساب
   reportTransactionGuildBtn: 'bfo.guilds.transactionsGuild', //  دکمه گزارش صورتحساب

   invoiceGuildBtn: 'accounts.guild.invoice.read', //  دکمه گزارش فاکتور
   invoiceGuildExportBtn: 'accounts.guild.invoice.export', //  دکمه گزارش فاکتور  - خروجی فایل
   invoiceGuildCallbackBtn: 'accounts.guild.invoice.read.callback', //  دکمه گزارش فاکتور  - بازگشت 
   invoiceGuildOperationBtn: 'accounts.guild.invoice.read.operation', //  دکمه گزارش فاکتور  - عملیات 
   invoiceGuildPaymentBtn: 'accounts.guild.invoice.read.payment', //  دکمه گزارش فاکتور  -  پرداخت عملیات 
   invoiceGuildGroupBtn: 'accounts.guild.invoice.read.group', //  دکمه گزارش فاکتور  -   عملیات گروهی  

   requestsGuildBtn: 'accounts.guild.cartable-requests.read.button', //  دکمه گزارش درخواست
   detailRequestsGuildBtn: 'accounts.guild.cartable-requests.read.button.detail', //  دکمه گزارش درخواست- جزئیات
   cancelRequestsGuildBtn: 'accounts.guild.cartable-requests.read.button.cancel', //  دکمه گزارش درخواست- لغو
   requestsSettlementGuildBtn: 'accounts.guild.settlement.read.button.export', //  دکمه گزارش درخواستهای تسویه
   requestsSettlementGuildExportBtn: 'accounts.guild.settlement.export', // -  و خروجی -  دکمه گزارش درخواستهای تسویه
   requestsSettlementGuildExportListBtn: 'accounts.guild.settlement-list.export', // -  و خروجی -  دکمه گزارش درخواستهای تسویه


   settlementGuildBtn: 'accounts.guild.settlement.create', //  دکمه فعال سازی تسویه خودکار
   updateNameGuildBtn: 'accounts.guild.update', // ویرایش نام حساب تفصیلی
   permissionsGrantedGuildBtn: 'accounts.guild.granted-permission.read', //  دکمه مجوز های مالی اعطا شده
   permissionsReceiveGuildBtn: 'accounts.guild.receive-permission.read', //  دکمه مجوز های مالی دریافت شده
   newPermissionsGrantedGuildBtn: 'accounts.guild.granted-permission.create', //  دکمه اعطای مجوز مالی

   createNewGuildBtn: 'accounts.guild.create', //  ایجاد حساب تفصیلی جدید
   reportOfflineGuildBtn: 'accounts.guild.report.offline', //  لیست گزارش صورتحساب


   // /grant-permission/list -  مجوز های مالی
   permissionsGuildBtn: 'bfo.guilds.grant-permission.list', //  مجوز های مالی
   permissionsUpdateGuildBtn: 'accounts.guild.permissions.confirm', // دکمه تایید درخواست
   permissionsCancelGuildBtn: 'accounts.guild.permissions.cancel', // دکمه لغو درخواست
   permissionsDeleteGuildBtn: 'accounts.guild.permissions.delete', // دکمه حذف مجوز 

   // /ReceivedGuild -   مجوز های مالی دریافت شده
   permissionsReceiveUpdateGuildBtn: 'accounts.guild.receive-permission.confirm',
   permissionsReceiveCancelGuildBtn: 'accounts.guild.receive-permission.cancel',  // مجوز های مالی دریافت شده
   permissionsReceiveDeleteGuildBtn: 'accounts.guild.receive-permission.delete', // مجوز های مالی دریافت شده

   // /ReceivedGuild -   مجوز های مالی اعطا شده
   permissionsGrantedUpdateGuildBtn: 'accounts.guild.granted-permission.confirm', // مجوز های مالی اعطا شده
   permissionsGrantedCancelGuildBtn: 'accounts.guild.granted-permission.cancel',
   permissionsGrantedDeleteGuildBtn: 'accounts.guild.granted-permission.delete', // مجوز های مالی اعطا شده

   // /TransactionsGuild - صورت حساب تراکنش
   reportTransactionGuildBtn: 'accounts.guild.report.transaction.read', // دکمه رسید تراکنش
   reportShareGuildBtn: 'accounts.guild.report.transaction.read', // دکمه اشتراک گذاری 
   reportPdfGuildBtn: 'accounts.guild.report.transaction.read', // دکمه دریافت pdf
   reportGuildPage: 'accounts.guild.report', // صورت حساب تراکنش
   reportGuildDocumentBtn: 'accounts.guild.report.document', // صورت حساب تراکنش- مدارک
   reportGuildTagBtn: 'accounts.guild.report.tag', // صورت حساب تراکنش- برچسب 

   // /GuildCartableCashOut - برداشت وجه کارتابلی
   withdrawMultipleShowGuildBtn: 'accounts.guild.multiple-withdraw.read', // دکمه مشاهده لیست درخواست ها
   withdrawMultipleGroupGuildBtn: 'accounts.guild.multiple-withdraw', // برداشت وجه گروهی


   // /SettlementGuild - درخواست‌های تسویه از حساب تفصیلی
   exportSettlementGuildBtn: 'accounts.guild.settlement.export', //  دریافت فایل خروجی
   settlementGuildPage: 'bfo.guilds.settlement-list', //  لیست صفحه

   // /Cartable/List - کارتابل
   contentCartblePage: 'bfo.cartable.list', // لیست کارتابل
   contentListCartbleBtn: 'accounts.cartable.read.button', //  لیست کارتابل درخواست دکمه درخواست ها
   contentRequestCartblePage: 'bfo.cartable.Request.list', //  لیست کارتابل درخواست
   CancelRequestCartbleBtn: 'accounts.cartable-requests.cancel', //  لیست کارتابل درخواست - لغو 
   detailsRequestCartbleBtn: 'bfo.cartable.Request.list.details', //  لیست کارتابل درخواست - جزئیات 


   // /cards - دفترچه
   shebaCardPage: 'bfo.sheba.list', //  تب شبا
   shebaImprestCardPage: 'org.imprest.sheba.list', //  تب شبا
   shebaNeWCardPage: 'accounts.sheba.create', // ایجاد شبا جدید
   shebaImprestNeWCardPage: 'org.imprest.accounts.sheba.create', // ایجاد شبا جدید

   shebaDeleteCardPage: 'accounts.sheba.delete', // حذف شبا 
   shebaImprestDeleteCardPage: 'org.imprest.accounts.sheba.delete', // حذف شبا 

   shebaUpdateCardPage: 'accounts.sheba.update', // ویرایش شبا  
   shebaImprestUpdateCardPage: 'org.imprest.accounts.sheba.update', // ویرایش شبا  


   cardsCardPage: 'bfo.cards.list', // تب کارت های بانکی
   cardsImprestCardPage: 'org.imprest.cards.list', // تب کارت های بانکی

   cardsNewCardPage: 'accounts.cards.create', // ایجاد کارت های بانکی جدید
   cardsImprestNewCardPage: 'org.imprest.accounts.cards.create', // ایجاد کارت های بانکی جدید

   cardsDeleteCardPage: 'accounts.cards.delete', // حذف کارت های بانکی 
   cardsImprestDeleteCardPage: 'org.imprest.accounts.cards.delete', // حذف کارت های بانکی 


   cardsUpdateCardPage: 'accounts.cards.update', // ویرایش کارت های بانکی 
   cardsImprestUpdateCardPage: 'org.imprest.accounts.cards.update', // ویرایش کارت های بانکی 


   contactsCardPage: 'bfo.contact.list', // تب لیست مخاطبین
   contactsImprestCardPage: 'org.imprest.contact.list', // تب لیست مخاطبین

   contactsNewCardPage: 'accounts.contacts.create', // تب لیست مخاطبین
   contactsImprestNewCardPage: 'org.imprest.accounts.contacts.create', // تب لیست مخاطبین

   contactsDeleteCardPage: 'accounts.contacts.delete', // حذف لیست مخاطبین 
   contactsImprestDeleteCardPage: 'org.imprest.accounts.contacts.delete', // حذف لیست مخاطبین 

   contactsUpdateCardPage: 'accounts.contacts.update', // ویرایش لیست مخاطبین 
   contactsImprestUpdateCardPage: 'org.imprest.accounts.contacts.update', // ویرایش لیست مخاطبین 


   // /DefineDelegation - تفویض وجه
   contentsDelegationPage: 'accounts.delegation.create', // تفویض وجه تکی/گروهی 
   multipleAccountDelegationBtn: 'accounts.delegation.create', //  گزارش تفویض وجه های گروهی
   multipleAccountDelegationGuildBtn: 'accounts.delegation.guild.create', //  گزارش تفویض وجه های گروهی

   selfAccountDelegationPage: 'bfo.delegation.list', //  وجه های تفویض شده به من
   exportAccountDelegationBtn: 'accounts.delegation.self.export', //  وجه های تفویض شده به من/  دریافت فایل خروجی
   transferAccountDelegationBtn: 'bfo.delegation.self.transfer', //  وجه های تفویض شده به من/  انتقال به سایرن
   defaultAccountDelegationBtn: 'accounts.delegation.self.default', //   وجه های تفویض شده به من / ستاره دار
   detailAccountDelegationBtn: 'accounts.delegation.self.detail', //   وجه های تفویض شده به من / ستاره دار


   accountDelegationOtherPage: 'bfo.delegation.define.list', // وجه های تفویض شده به سایرین
   updateDelegationOtherPage: 'accounts.delegation.other.update', //  تغییر وضعیت / وجه های تفویض شده به سایرین
   exportDelegationOtherPage: 'accounts.delegation.other.export', //  دریافت فایل خروجی/ وجه های تفویض شده به سایرین
   detailsDelegationOtherPage: 'accounts.delegation.other.read.details', //  -  جزئیات-  دریافت فایل خروجی/ وجه های تفویض شده به سایرین

   // /WithdrawRules/NewRule - مجوزهای برداشت از حساب مشتری
   createWithdrawRulesPage: 'bfo.withdraw-rules.define', // قانون برداشت جدید
   contentsWithdrawRulesPage: 'bfo.withdraw-rules.list', //  لیست قوانین برداشت
   reciveLinksWithdrawRulesBtn: 'accounts.rules.enable-link.read', //  دریافت لینک فعال سازی
   permitsWithdrawRulesBtn: 'bfo.withdraw-rules.customers', // لیست مجوزهای برداشت      

   //=================== مدیریت کسب و کار - شعبه ها و زیرمجموعه ها ================================================
   /**
   * زیرمجموعه های من - عملیات - 
   */
   addSubbusinessPage: 'org.branch.subbusiness.define', // 'افزودن زیر مجموعه'  
   /**
       * زیرمجموعه های من
       */
   branchSubbusinessPage: 'org.branch.subbusiness.list', // 'زیرمجموعه های من'
   /**
    * زیرمجموعه های من - عملیات - 
    */
   delegationSubbusinessPage: 'services.subbusiness.delegation', // 'تفویض'  
   /**
    * زیرمجموعه های من - عملیات - 
 */
   detailSubbusinessPage: 'services.subbusiness.detail', // جزئیات
   /**
    * زیرمجموعه های من - عملیات - 
    */
   updateSubbusinessPage: 'services.subbusiness.update', // ویزایش
   /**
    * ایجاد شعبه
    */
   branchAddNew: 'org.branch.define', // 'ایجاد شعبه ' 
   /**
     * دکمه شارژ حساب 
     */
   branchListChargeBtn: 'services.branch.list.charge', // 'لیست شعبه ' 

   /**
   * دکمه صورتحساب 
   */
   branchListReportBtn: 'services.branch.list.report', // 'لیست شعبه ' 

   /**
    * دسترسی در لیست شعبه ها
    */
   branchListTable: 'org.branch.list', //  جدول در لیست شعبه ها
   /**
    * عملیات ویرایش در لیست شعب
    */
   branchListOperationAction: 'services.branches.operation', // عملیات - عملیات  در لیست شعب

   /**
    * عملیات جزییات در لیست شعب
    */
   branchListDetailAction: 'services.branches.report',  // عملیات جزییات در لیست شعب



   /**
      * عملیات انتقال وجه در لیست شعب در قسمت عملیات ملی
      */
   branchListTransferAction: 'services.branches.financial', //* عملیات  در لیست شعب در قسمت عملیات ملی


   /**
    * لیست شعبه -عملیات صورتحساب - مدارک
    */
   branchTransactionBillDocumentAction: 'services.branches.report',
   /**
    * لیست شعب - عملیات صورتحساب - عملیات برچسب
    */
   branchTransactionBillTagAction: 'services.branches.report',
   /**
    * لیست شعب - عملیات صورتحساب - رسید تراکنش
    */
   branchTransactionBillAction: 'services.branches.report',

   /**
    * دکمه گزارش تفویض وجه در شعب - تفویض وجه - بالای صفحه
    */
   branchDelegationReportBtn: 'services.branches.financial',

   /**
    * دکمه دریافت فایل خروجی در لیست شعب - صورتحساب
    */
   branchTransactionBillExportBtn: 'services.branches.report',



   //=================== خدمات سازمانی - تنخواه گردان =================================================================.



   /**
* برچسب گذاری  در صفحه لیست تنخواه گردان
*/
   imprestListReportTransactionTags: 'services.imprest.list.report.tag',
   /**
* مدارک در صفحه لیست تنخواه گردان
*/
   imprestListReportTransactionDocument: 'services.imprest.list.report.document',
   /**
* رسید تراکنش در صفحه لیست تنخواه گردان
*/
   imprestListReportTransactionRead: 'services.imprest.list.report.transaction.read',
   /**
* دکمه دریافت فایل - گزارش صورتحساب در صفحه لیست تنخواه گردان
*/
   imprestListReportExport: 'services.imprest.list.report.export',

   /**
 * دکمه شارژ حساب  در صفحه لیست تنخواه گردان
 */
   imprestListChargeBtn: 'services.imprest.list.charge',
   /**
* دکمه گزارشات  در صفحه لیست تنخواه گردان
*/
   imprestListReportBtn: 'services.imprest.list.report',
   /**
    * دکمه سابمیت در صفحه ایجاد تنخواه گردان
    */
   imprestAddNewPage: 'org.imprest.define',
   /**
    * دکمه ریدارکت به ایجاد تنخواه گردان در صفحه لیست تنخواه گردان
    */
   imprestListRedirectToAddImprestBtn: 'services.imprest.create.button',
   /**
    * دکمه بازگشت به لیست تنخواه گردان در بالای صفحه ایجاد تنخواه گردان
    */
   addImprestBackBtn: 'services.imprest.read.button',
   /**
    * دسترسی جدول در لیست تنخواه گردان
    */
   imprestListTable: 'org.imprest.list',
   /**
    * اکشن انتقال وجه در لیست تنخواه گردان
    */
   imprestListTransferAction: 'services.imprest.financial',
   /**
    * اکشن تفویض وجه در لیست تنخواه گردان
    */
   imprestListDelegationAction: 'services.imprest.financial',
   /**
    * اکشن سقف مالی شعبه در لیست تنخواه گردان قسمت عملیات مالی
    */
   imprestListFinancialLimitAction: 'services.imprest.financial',

   /**
    * اکشن عملیات انتقال وجه از طرف در لیست تنخواه گردان در قسمت عملیات از طرف تنخواه گردان
    */
   imprestListOtherTransferAction: 'services.imprest.other',
   /**
    * اکشن عملیات صدور فاکتور در لیست تنخواه گردان در قسمت عملیات از طرف تنخواه گردان
    */
   imprestListOtherInvoiceCreateAction: 'services.imprest.other',

   /**
    * اکشن عملیات امکان دریافت موجودی در لیست تنخواه گردان در قسمت عملیات از طرف تنخواه گردان
    */
   imprestListOtherBalanceAction: 'services.imprest.other',
   /**
    * اکشن عملیات ویرایش در لیست تنخواه گردان در قسمت عملیات 
    */
   imprestListUpdateAction: 'services.imprest.operation',
   /**
    * اکشن عملیات فعال و غیرفعال سازی شعبه در لیست تنخواه گردان در قسمت عملیات 
    */
   imprestListUpdateActivationAction: 'services.imprest.operation',

   /**
    * اکشن عملیات جزییات در لیست تنخواه گردان در قسمت گزارش 
    */
   imprestListDetailAction: 'services.imprest.report',

   /**
    * اکشن عملیات صورتحساب در لیست تنخواه گردان در قسمت گزارش 
    */
   imprestListBillAction: 'services.imprest.report',
   /**
    * لیست تنخواه گردان -عملیات صورتحساب - مدارک
    */
   imprestTransactionBillDocumentAction: 'services.imprest.report',
   /**
    * لیست تنخواه گردان - عملیات صورتحساب - عملیات برچسب
    */
   imprestTransactionBillTagAction: 'services.imprest.report',
   /**
    * لیست تنخواه گردان - عملیات صورتحساب - رسید تراکنش
    */
   imprestTransactionBillAction: 'services.imprest.report',

   /**
    * دکمه گزارش تفویض وجه در تنخواه گردان - تفویض وجه - بالای صفحه
    */
   imprestDelegationReportBtn: 'services.imprest.financial',
   /**
    * دکمه دریافت فایل خروجی در لیست تنخواه گردان - صورتحساب
    */
   imprestTransactionBillExportBtn: 'services.imprest.report',
   /**
    *  گزارش کل تنخواه
  */
   imprestFunderPage: 'org.imprest.funder',
   /**
    * گزارش تجمعی - دریافت فایل خروجی - گزارش کل تنخواه
    */
   exportImprestFunderPage: 'services.all.imprest.export',
   /**
    * گزارش تجمعی - درخواست فایل خروجی - گزارش کل تنخواه
   */
   exportAggregationAllImprestFunderPage: 'services.all.aggregation.imprest.export',
   /**
 * لیست درخواست ها - گزارش کل تنخواه
*/
   offlineListAllImprestFunderPage: 'services.all.imprest.offline',
   /**
 * عملیات - گزارش کل تنخواه
*/
   operationAllImprestFunderPage: 'services.all.imprest.operation',


   //==================خدمات سازمانی - بن شارژ ================================================================================

   /**
 * بن شارژ - ایجاد بن شارژ
 */
   AddCreditVouchersPage: 'financial.followers.list.customers.credit-voucher.button',
   AddCreditVouchersBtn: 'org.credit-voucher.guild.define.create.button',
   AddCreditVouchersSecoundBtn: 'org.credit-voucher.digital.define.create.button',

   /**
   * بن شارژ - لیست  بن شار - تغییر وضعیت
   */
   toggleListCreditVoucher: 'org.credit-voucher.toggle.button',

   /**
    * بن شارژ - لیست بن شارژ
    */
   creditVoucherList: 'org.creditvoucher.list',
   /**
    * لیست بن شارژ - اکشن جزییات در ستون عملیات
    */
   creditVoucherDetailAction: 'org.credit-voucher.list.detail.button',
   /**
    * بن  تخفیف - دکمه دریافت فایل خروجی
    */
   creditVoucherExportBtn: 'org.credit-voucher.export.button',

   //================= خدمات سازمانی - بن تخفیف ==============================================================================
   /**
    * بن تخفیف - ایجاد بن تخفیف
    */
   AddVoucher: 'org.vouchers.define',
   /**
 * بن تخفیف - ایجاد بن تخفیف
 */
   AddVoucherCustomersPage: 'financial.followers.list.customers.voucher.button',
   /**
 * بن تخفیف - ایجاد بن های  تخفیف 
 */
   AddVouchersBtn: 'org.voucher.list',
   /**
    * بن تخفیف - لیست بن تخفیف
    */
   voucherList: 'org.voucher.list',
   /**
    * بن تخفیف - اکشن جزییات
    */
   voucherDetailAction: 'org.voucher.list',
   /**
    * بن تخفیف - اکشن سوییچ تغییر وضعیت
    */
   voucherToggleStatusAction: 'org.voucher.list.toggle.button',
   /**
    * بن  تخفیف - دکمه دریافت فایل خروجی
    */
   voucherExportBtn: 'org.voucher.list.export.button',
   //=============== خدمات سازمانی - تامین مالی ===================================================================================>
   /**
    * تامین مالی - درخواست اعتبار - کلید نمایش محتوای این صفحه است
    */
   invoiceFinancingRequestPage: 'org.invoice-financing.request',
   /**
    * تامین مالی - فاکتورهای تامین مالی شده - کلید نمایش محتوای این صفحه است
    */
   invoiceFinancingPage: 'org.invoice-financing.invoices',
   /**
    * تامین مالی - فاکتورهای تامین مالی شده - ستون عملیات مشاهده و پرداخت اقساط
    */
   invoiceFinancingPayAction: 'org.invoice-financing.invoices',

   /**
    * تامین مالی - فاکتورهای تامین مالی شده - ستون عملیات مشاهده و پرداخت اقساط - پرداخت در ستون های دیالوگ
    */
   invoiceFinancingPayInDgAction: 'org.invoice-financing.invoices',

   /**
       * تامین مالی - فاکتورهای تامین مالی شده - ستون عملیات مشاهده و پرداخت اقساط - تسویه زودتر از موعد دیالوگ
       */
   invoiceFinancingPaySoonerInDgAction: 'org.invoice-financing.invoices',

   //====================== خدمات سازمانی - تسهیلات ============================================================>
   /**
    * تسهیلات دریافتی
    */
   loanListPage: 'org.loan.list', //'org.loan.list.page',
   /**
    * تسهیلات دریافتی - اکشن جزییات در ستون های جدول
    */
   loanDetailAction: 'org.loan.list',
   /**
    * تسهیلات دریافتی - اکشن مشاهده و پرداخت در ستون های جدول
    */
   loanPayAction: 'org.loan.list',
   /**
    * تسهیلات دریافتی - اکشن مشاهده و پرداخت - پرداخت در ستون های دیالوگ
    */
   loanPayPayAction: 'org.loan.list.installment-pay.pay.button',
   /**
    * * تسهیلات دریافتی - اکشن مشاهده و پرداخت - پرداخت زودتر از موعد در دیالوگ
    */
   loanPayPaySoonerAction: 'org.loan.list.installment-pay.sooner.button',
   /**
    * تسهیلات  - فروش اقساطی - لیست و نمایش فیلتر
    */
   loanSaleListPage: 'org.loan.sales',
   /**
    * تسهیلات - فروش اقساطی - دکمه دریافت خروجی فایل
   */
   loanSaleListExportBtn: 'org.loan.sales.export.button',
   /**
  * تسهیلات - فروش اقساطی - عملیات 
 */
   loanSaleListDetailBtn: 'org.loan.sales',
   /**
* تسهیلات - ضمانت نامه - درخواست صدور
*/
   requestWarrantyPage: 'org.warranty.requests',
   /**
* تسهیلات - ضمانت نامه -  لیست درخواست ها
*/
   listWarrantyPage: 'org.warranty.list',

   /**
* تسهیلات - ضمانت نامه -  لیست درخواست ها
*/
   listWarrantyDetailPage: 'org.warranty.detail',

   /**
* خدمات سازمانی-> ضمانت نامه دیجیتال-> لیست درخواست ها -> عملیات -> لغو درخواست
*/
   cancelListWarrantyPage: 'org.warranty.requests.cancel',

   /**
* خدمات سازمانی-> کارگذاری-> لیست کارگذاری های من
*/
   listDealerPage: 'org.dealer.list',

   /**
* خدمات سازمانی-> کارگذاری-> لیست کارگذاری های من-> افزودن کارگزار
*/
   addListDealerBtn: 'org.dealer.list.add.accept.button',

   /**
* خدمات سازمانی-> کارگذاری-> لیست کارگذاری های من-> تغییر وضعیت
*/
   toggleListDealerBtn: 'org.dealer.list.toggle.button',
   /**
* خدمات سازمانی-> کارگذاری-> لیست کارگذاری های من-> لیست محصولات
*/
   productListDealerBtn: 'org.dealer.list.product-list.button',
   /**
* خدمات سازمانی-> کارگذاری-> مجوزهای کارگزاری من
*/
   listDealingPage: 'org.dealing.list',

   dealingProdcutList: 'org.dealing.list.product-list',
   //======================  پشتیبانی   ============================================================>

   contentFaqSupportingPage: 'ticketing.faq', // صفحه سوالات متداول 
   contentTicketListSupportingPage: 'ticketing.list.support', // تیکت های پشتیبانی فنی
   contentTicketListDetailSupportingPage: 'ticketing.list.support.details.button', // جزئیات تیکت های پشتیبانی فنی  
   contentTicketListCloseSupportingPage: 'ticketing.list.support.close.button', // بستن  تیکت های پشتیبانی فنی  
   contentTicketListCancelSupportingPage: 'ticketing.list.support.cancel.button', // لغو تیکت های پشتیبانی فنی  
   createTicketSupportingPage: 'ticketing.list.support.page.create', // ایجاد تیکت  / تیکت های پشتیبانی فنی  


   createTicketPage: 'ticketing.create.page', // ایجاد تیکت 
   contentTicketListSalePage: 'ticketing.list.sale', //تیکت‌های مدیریت مشتریان پاد
   contentTicketListDetailSalePage: 'ticketing.list.sale.detail.button', // جزئیات مدیریت مشتریان پاد  
   contentTicketListCloseSalePage: 'ticketing.list.sale.close.button', // بستن مدیریت مشتریان پاد  
   contentTicketListCancelSalePage: 'ticketing.list.sale.cancel.button', // لغو مدیریت مشتریان پاد  
   createTicketSalePage: 'ticketing.list.sale.page.create', // ایجاد تیکت  / جزئیات مدیریت مشتریان پاد  

   //======================  میز کار    ============================================================>

   contentDashboardPage: 'dashboard', // صفحه میز کار  
   contentGuildDashboardPage: 'dashboard', // صفحه میز کار  
   reportGuildWalletDashboardBtn: 'dashboard.wallet-guild-report.read', // گزارش تلفیقی 
   exportReportGuildWalletDashboardBtn: 'dashboard.wallet-guild-report.export', // گزارش تلفیقی  - دریافت فایل
   accountGuildDashboardBtn: 'dashboard.guild.account', // لینک حساب تفضیلی -  میز کار  
   accountWalletDashboardBtn: 'dashboard.digital.account', // لینک حساب دیجیتال -  میز کار  
   updateBusinessDashboardBtn: 'dashboard.update.business', // ویرایش اطلاعات کسب و کار -  میز کار  
   /**
  * تلفیقی */
   exportListDetailActionBtn: 'dashboard.wallet-guild-report.offline-report',  //تلفیقی
   //======================  فروش و مشتریان   ============================================================>

   invoiceFinancialPage: 'financial.issue-invoice',  // صدور فاکتور
   invoiceFinancialBtn: 'financial.issue-invoice',  // صدور فاکتور دکمه صدور

   productsReportFinancialPage: 'financial.income-products',  // گزارش درآمد بر اساس محصولات
   exportProductsReportFinancialPage: 'financial.income-products.report.export.button',  //- دریافت فایل -  گزارش درآمد بر اساس محصولات

   guildsIncomeFinancialPage: 'financial.income-guilds',  // گزارش درآمد بر اساس حساب تفصیلی 
   guildsIncomeDetailFinancialBtn: 'financial.income-guilds',  // گزارش درآمد بر اساس حساب تفصیلی - جزئیات
   exportGuildsIncomeDetailFinancialBtn: 'financial.income-guilds.export.button',  // گزارش درآمد بر اساس حساب تفصیلی - دریافت فایل

   followersListFinancialPage: 'financial.followers.list',  // لیست مشتریان
   followersListTransferFinancialBtn: 'financial.followers.list.customer-invoices.transfer.button',  //    انتقال وجه - لیست مشتریان
   followersListVoucherFinancialBtn: 'financial.followers.list.customers.voucher.button',  //     بن تخفیف - لیست مشتریان
   followersListInvoicesFinancialBtn: 'financial.followers.list.customer-invoices.button',  //       فاکتورهای مشتری - لیست مشتریان
   followersListCreditVoucherFinancialBtn: 'financial.followers.list.customers.credit-voucher.button',  //        بن شارژ - لیست مشتریان
   followersListInvoiceFinancialBtn: 'financial.followers.list.customers.issue-invoice.button',  //        صدور فاکتور - لیست مشتریان
   followersListFinancialExportPage: 'financial.followers.list.customer-invoices.export',  // لیست مشتریان -  دریافت حروجی
   followersListFinancialPaymentBtn: 'financial.followers.list.customer-invoices.payment',  // لیست مشتریان -  ارسال پیامک پرداخت 
   followersListFinancialOperationBtn: 'financial.followers.list.customer-invoices.operation',  // لیست مشتریان -   عملیات  
   followersListFinancialCallbackBtn: 'financial.followers.list.customer-invoices.callback',  // لیست مشتریان -   مشاهده آدرس بازگشت  
   followersListFinancialGroupInvoiceBtn: 'financial.followers.list.customer-invoices.group',  // لیست مشتریان - بستن گروهی    


   invoiceCreditorFinancialPage: 'financial.invoice.creditor',  // فاکتورهای خرید
   paymentInvoiceCreditorFinancialBtn: 'financial.invoice.creditor.digital.payment.button',  // فاکتورهای خرید -   پرداخت با حساب دیجیتال
   invoiceCreditorDetailFinancialPage: 'financial.invoice.creditor',  // فاکتورهای خرید -  جزئیات
   exportinvoiceCreditorFinancialBtn: 'financial.invoice.creditor.export.button',  // فاکتورهای خرید -  دریافت فایل
   paymentLinkInvoiceCreditorFinancialBtn: 'financial.invoice.creditor.payment-link.button',  // فاکتورهای خرید - لینک پرداخت

   invoicListFinancialPage: 'financial.invoice.list',  // فاکتورهای فروش 
   exportInvoicListFinancialBtn: 'financial.invoice.list.export.button',  // فاکتورهای فروش -  دریافت فایل خروجی
   paymentInvoicListFinancialBtn: 'financial.invoice.payment',  // فاکتورهای فروش -  لینک پرداخت
   operationInvoicListFinancialBtn: 'financial.invoice.operation',  // فاکتورهای فروش -  جزئیات
   closeGroupInvoicListFinancialBtn: 'financial.invoice.group',  // فاکتورهای فروش -  بستن گروهی  فاکتور
   callbackInvoicListFinancialBtn: 'financial.invoice.callback',  // فاکتورهای فروش -    بازگشت


   //======================  مدیریت سرویس     ============================================================>

   createDefineSubscriptionsPage: 'service.subscriptions.define', // ایجاد طرح اشتراک
   cancelCreateDefineSubscriptionsBtn: 'service.subscriptions.define.cancel.button',  // ایجاد طرح اشتراک - انصراف
   backDefineSubscriptionsBtn: 'service.subscriptions.define.back-to-list.button',  // ایجاد طرح اشتراک - دکمه بازگشت لیست 

   listSubscriptionsPage: 'service.subscriptions.list', // طرح‌های تعریف شده
   newSubscriptionBtn: 'service.subscriptions.list.new-subscription.button',  // طرح‌های تعریف شده جدید
   exclusiveActiveSubscriptionsBtn: 'service.subscriptions.list.exclusive-active.button',  // طرح‌های تعریف شده - فعالسازی اختصاصی
   editSubscriptionsBtn: 'service.subscriptions.list.edit-subscription.button',  // طرح‌های تعریف شده - ویرایش

   subScriptionServicePage: 'service.subscriptions.active', // طرح‌های فعال  
   detailActiveSubscriptionsBtn: 'service.subscriptions.active.details.button', // طرح‌های فعال  

   requestListPage: 'service.request.list', // لیست درخواست‌های ارسالی
   exportRequestListBtn: 'service.request.list.export.button', // لیست درخواست‌های ارسالی -  دریافت فایل 

   requestCallPage: 'service.request.calls', // لیست فراخوانی سرویس‌ها
   exportRequestCallBtn: 'service.request.calls.export.button', // لیست فراخوانی سرویس‌ها - دریافت فایل 

   newWebServiceDefinePage: 'service.webservice.define', // تعریف وب سرویس
   cancelNewWebServiceDefineBtn: 'service.webservice.define', // تعریف وب سرویس -  دکمه انصراف

   requestSetServiceDefinePage: 'service.webservice.serviceset.request', // درخواستهای دریافتی
   exportRequestSetServiceDefinePage: 'service.web-service.service-set.request.export.button', // درخواستهای دریافتی - دریافت فایل خروجی

   newSetWebServiceDefinePage: 'service.webservice.serviceset.add', // تعریف مجموعه سرویس

   providersWebServicePage: 'service.webservice.service-providers', // گزارش فراخوانیها
   exportProvidersWebServiceBtn: 'service.web-service.service-providers.export',// گزارش فراخوانیها  - دریافت فایل

   myWebServiceListPage: 'service.webservice.list', // لیست سرویس‌های من
   subMyWebServiceListBtn: 'service.web-service.list.service-set.button', // لیست سرویس‌های من - مجموعه سرویس
   changeStatsMyWebServiceListBtn: 'service.web-service.list.toggle.button', // لیست سرویس‌های من - تغییر وضعیت 
   editMyWebServiceListBtn: 'service.web-service.list.edit.button', // لیست سرویس‌های من -  ویرایش
   cancelEditMyWebServiceListBtn: 'service.web-service.list.edit.cancel.button', // لیست سرویس‌های من -ویرایش  - انصراف 
   detailMyWebServiceListBtn: 'service.web-service.list.detail.button', // لیست سرویس‌های من - جزئیات 

   callsWebServiceListPage: 'service.webservice.service-calls', // لیست فراخوانی سرویس‌های من
   exportCallsWebServiceListBtn: 'service.web-service.service-calls.export.button', // لیست فراخوانی سرویس‌های من

   subMyWebServiceListPage: 'service.webservice.serviceset.list', // لیست مجموعه سرویس‌های من
   exportSubMyWebServiceListPage: 'service.web-service.service-set.list.export.button', // لیست فراخوانی سرویس‌های من - دریافت فایل
   editSubMyWebServiceListPage: 'service.web-service.service-set.list.edit.button', // لیست فراخوانی سرویس‌های من - ویرایش
   requestPublishSubMyWebServiceListPage: 'service.webservice.serviceset.list.share', // لیست فراخوانی سرویس‌های من - درخواست انتشار
   accountTransactionsPage: 'bfo.accounts.transactions', //* گزارش صورتحساب دیجیتال 
   accountTransactionsGuildPage: 'bfo.guilds.transactionsGuild', //* گزارش صورتحساب تفضیلی 
   branchTransactionPage: 'org.branch.transactions', //* گزارش صورتحساب شعبه
   imprestTransactionPage: 'org.imprest.transactions', //* گزارش صورتحساب شعبه

   imprestTransactionReportExportBtn: 'org.imprest.transactions.report.export', //*   خدمات تنخواه گردانی ->گزارش صورت حساب تنخواه گردان
   imprestTransactionReportReadBtn: 'org.imprest.transactions.report.transaction.read', //*   خدمات تنخواه گردانی ->گزارش صورت حساب تنخواه گردان
   imprestTransactionReportDocumentBtn: 'org.imprest.transactions.report.document', //*   خدمات تنخواه گردانی ->گزارش صورت حساب تنخواه گردان
   imprestTransactionReportTagBtn: 'org.imprest.transactions.report.tag', //*   خدمات تنخواه گردانی ->گزارش صورت حساب تنخواه گردان


   branchTransactionReportExportBtn: 'org.branch.transactions.report.export', //* مدیریت کسب و کار -> شعبه ها و زیرمجموعه ها ->گزارش صورت حساب شعبه
   branchTransactionReportReadBtn: 'org.branch.transactions.report.transaction.read', //*   مدیریت کسب و کار -> شعبه ها و زیرمجموعه ها ->گزارش صورت حساب شعبه
   branchTransactionReportDocumentBtn: 'org.branch.transactions.report.document', //*   مدیریت کسب و کار -> شعبه ها و زیرمجموعه ها ->گزارش صورت حساب شعبه
   branchTransactionReportTagBtn: 'org.branch.transactions.report.tag', //*   مدیریت کسب و کار -> شعبه ها و زیرمجموعه ها ->گزارش صورت حساب شعبه

   transactionsGuildTransactionReportExportBtn: 'bfo.guilds.transactionsGuild.report.export', //* عملیات مالی و بانکی--> حساب تفصیلی--> گزارش صورتحساب تفصیلی
   transactionsGuildTransactionReportReadBtn: 'bfo.guilds.transactionsGuild.report.transaction.read', //*   عملیات مالی و بانکی--> حساب تفصیلی--> گزارش صورتحساب تفصیلی
   transactionsGuildTransactionReportDocumentBtn: 'bfo.guilds.transactionsGuild.report.document', //*   عملیات مالی و بانکی--> حساب تفصیلی--> گزارش صورتحساب تفصیلی
   transactionsGuildTransactionReportTagBtn: 'bfo.guilds.transactionsGuild.report.tag', //*  عملیات مالی و بانکی--> حساب تفصیلی--> گزارش صورتحساب تفصیلی


   imprestCardService: 'services.imprest.card', //*  خدمات تنخواه گردانی--> لیست تنخواه گردان --> خدمات کارت
   digitalCardService: 'accounts.digital.card', //*  عملیات مالی و بانکی--> حساب دیجیتال من--> خدمات کارت  


});
// 'clients.create',